module.exports = __webpack_public_path__ + "img/reference14.602ee2f4.jpg";